import moment from 'moment'
import generateUniqueId from 'apps/utility/generateUniqueId'

const now = moment()
  .utcOffset(-5, true)
  .format('YYYY-MM-DDTHH:mm:ss')

export function createViewThroughCookie(pageName, cookieName, brlid) {
  const cookie = JSON.stringify({
    createDate: now,
    lastVisit: now,
    visits: 1,
    product: pageName,
    brlid: brlid,
    cookieId: generateUniqueId(15)
  })

  document.cookie = `${cookieName}=${encodeURIComponent(
    cookie
  )}; domain=${window.cookieDomain || '.bankrate'}; path=/`
}

export function fetchCookiesAsObject(cookie = document.cookie) {
  const cookieObject = {}
  cookie.split('; ').forEach(item => {
    const splitItem = item.split('=')
    cookieObject[splitItem[0]] = splitItem[1] ? splitItem[1] : null
  })

  return cookieObject
}

export function processcookieName(pageName, cookieName, brlid) {
  const activeCookies = fetchCookiesAsObject()
  if (activeCookies.hasOwnProperty(cookieName)) {
    const cookie = JSON.parse(decodeURIComponent(activeCookies[cookieName]))
    cookie.lastVisit = now
    cookie.visits = parseInt(cookie.visits) + 1
    cookie.brlid = brlid

    document.cookie = `${cookieName}=${encodeURIComponent(
      JSON.stringify(cookie)
    )}; domain=${window.cookieDomain || '.bankrate'}; path=/`
  } else {
    createViewThroughCookie(pageName, cookieName, brlid)
  }
}
